import React, { useEffect } from 'react';
import CheckoutDispositionInfo from 'organisms/CheckoutDispositionInfo/container/CheckoutDispositionInfo';
import CheckoutDispositionOptions from 'organisms/CheckoutDispositionOptions/container/CheckoutDispositionOptions';
import CheckoutContactInfo from 'organisms/CheckoutContactInfo/container/CheckoutContactInfo';
import Payment from 'organisms/Payment/container/Payment';
import PriceSummary from 'organisms/PriceSummary/container/PriceSummary';
import CheckoutViewHOC from '../CheckoutViewHOC';
import { isCateringDisposition, isDeliveryDisposition } from 'common/utilities/utils';
import { displayNotifyMessage } from 'common/sharedTemplates/sharedTemplates';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { CATERING, PAYMENT_TENDER_TYPES } from '../../../../common/constants/SharedConstants';
import CheckoutDeliveryTippingViews from 'organisms/CheckoutDeliveryTipping/presentation/CheckoutDeliveryTippingViews';

const CheckoutView = props => {
  const { updateCheckoutDetails, checkoutDetails } = props;
  const {
    type,
    userParams,
    showPreValidationPaymentContactError,
    secondarycontact,
    isCateringSomeOneElseContactDetailsAreValid,
    isContactDetailValid,
    displayDeliveryTipping,
    tender,
    enableTipping
  } = checkoutDetails;

  useEffect(() => {
    tender?.name && tender?.name === PAYMENT_TENDER_TYPES?.PAY_BY_CASH
      ? updateCheckoutDetails({
          enableTipping : false,
          driverdeliveryTip: 0,
          total: props?.checkoutDetails?.cartTotal,
          driverTipDisplayAmount: 0,
        })
      : updateCheckoutDetails({ enableTipping : true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tender?.name]);

  return (
    <CheckoutViewHOC {...props}>
      {/* Gust User Contact Info */}
      {!userParams?.loggedIn && <CheckoutContactInfo col-mob-left col-left {...props} />}

      {/* Disposition Info Session */}
      <CheckoutDispositionInfo col-mob-left col-left {...props} />

      {userParams?.loggedIn && secondarycontact?.toLowerCase()?.includes(type?.toLowerCase()) && (
        <CheckoutContactInfo col-mob-left col-left {...props} displayFor={CATERING} />
      )}

      {/* Options */}
      {isDeliveryDisposition(type) && <CheckoutDispositionOptions col-mob-left col-left {...props} />}

      {/* Price summary session */}
      <PriceSummary col-mob-left col-right {...props} />

      {/* Display Notify Message */}
      {((!userParams?.loggedIn &&
        !isCateringDisposition(type) &&
        showPreValidationPaymentContactError &&
        !isContactDetailValid) ||
        !isCateringSomeOneElseContactDetailsAreValid) && (
        <div col-mob-left col-left className='row row-cols-12 mt-10px no-bg' data-testid='contactdetail-alert'>
          {displayNotifyMessage(translateWithI18Next(TRANSLATE_MAPPING_KEY?.ADD_CONTACT_TO_ENABLE_PAYMENT))}
        </div>
      )}
      {/*Delivery Tipping */}
      {displayDeliveryTipping && enableTipping && isDeliveryDisposition(type) && (
        <CheckoutDeliveryTippingViews col-mob-left col-left {...props} />
      )}

      {/* Payment */}
      <Payment col-mob-left col-left {...props} />
    </CheckoutViewHOC>
  );
};

export default CheckoutView;
